/**
 * Compact React Flow node for a `transfer` (phone) builtin: a small phone icon
 * plus the transfer's function name. A phone number is an external endpoint —
 * nothing to test or expand — so it renders as a minimal pill rather than a full
 * agent card. The dialled number (when statically configured) shows on hover.
 */
import { Handle, Position } from 'reactflow';
import Sheet from '@mui/joy/Sheet';
import Typography from '@mui/joy/Typography';
import PhoneForwardedIcon from '@mui/icons-material/PhoneForwarded';

export const PHONE_NODE_WIDTH = 156;
export const PHONE_NODE_HEIGHT = 38;

export default function PhoneNode({ data }) {
  const handleStyle = { opacity: 0, width: 6, height: 6, border: 'none' };

  return (
    <Sheet
      variant="outlined"
      color="neutral"
      title={data.number ? `Transfers the call to ${data.number}` : 'Transfers the call to a phone number'}
      sx={{
        width: PHONE_NODE_WIDTH,
        height: PHONE_NODE_HEIGHT,
        boxSizing: 'border-box',
        px: 1,
        borderRadius: 'xl',
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        bgcolor: 'background.surface',
      }}
    >
      <Handle id="t" type="target" position={Position.Top} style={handleStyle} />
      <Handle id="l" type="target" position={Position.Left} style={handleStyle} />

      <PhoneForwardedIcon sx={{ fontSize: 16, color: 'text.tertiary', flexShrink: 0 }} />
      <Typography level="body-xs" noWrap sx={{ flex: 1, minWidth: 0, fontFamily: 'monospace' }}>
        {data.name}
      </Typography>
    </Sheet>
  );
}
